<pace-core-side-menu>
    <!-- cannot use a nested @if, as that would modify the DOM in a way that breaks the content projection -->
    @if (displayWeeklyWorkTime && enableNgRx) {
        <pace-weekly-work-time-ngrx
            paceWeeklyWorkTime
            [isWorkStartedForToday]="(isStartWorkAlreadySet$ | async) ?? false"
        ></pace-weekly-work-time-ngrx>
    } @else if (displayWeeklyWorkTime) {
        <pace-weekly-work-time
            paceWeeklyWorkTime
            [isWorkStartedForToday]="(isStartWorkAlreadySet$ | async) ?? false"
        ></pace-weekly-work-time>
    }
    <pace-information paceInformation></pace-information>
    @if (showCorporateEntry) {
        <pace-core-menu-entry corporateInformationMenuEntry [model]="corporateInformationEntry"></pace-core-menu-entry>
    }
</pace-core-side-menu>
<pace-core-navigation-link></pace-core-navigation-link>
@if (isPIScheduleActive$ | async) {
    <pace-physical-inventory-alert></pace-physical-inventory-alert>
}
<!-- Display numberOfMaterialsToBeReturned -->
<pace-return-material></pace-return-material>
<!--
removing the what's new element from the app header for as discussed
at the onsite workshop and in the ticket: https://evorait.atlassian.net/browse/SHP-8108

we're going to replace the functionality with some improved version in the future

<pace-core-whats-new></pace-core-whats-new>
-->
<ng-container *ngrxLet="isOnline$ as isOnline">
    <div
        class="gid px-3 py-0 cursor-pointer"
        [class.pe-none]="!isOnline"
        [class.opacity-50]="!isOnline"
        (click)="releaseLock()"
    >
        <fa-icon [icon]="isOnline ? faLock : faBan"></fa-icon>
        <span class="d-none d-lg-inline-block ps-2" [translate]="'DEVICE_LOCK_BUTTON'"></span>
    </div>
</ng-container>
@if (displaySync) {
    <pace-core-sync-indicator></pace-core-sync-indicator>
}
